import BaseElement from './base_element';

export default class LineElement extends BaseElement {
  constructor(managers, x, y, width, properties = {}) {
    super(managers, properties);
    this.element = this._createDomElement(x, y, width, properties);
    this._setupEvents();
  }

  _createDomElement(x, y, width, properties) {
    const element = document.createElement('div');

    element.className = 'canvas-element line-element';
    element.style.left = x + 'px';
    element.style.top = y + 'px';
    element.style.width = width + 'px';
    element.style.height = (properties.thickness || 1) + 'px';
    element.style.backgroundColor = properties.color || '#000000';
    element.style.pointerEvents = 'all';
    element.dataset.type = 'line';
    element.dataset.id = this.id;

    const hitArea = document.createElement('div');
    hitArea.className = 'line-hit-area';
    if ((properties.thickness || 1) >= 4) hitArea.style.display = 'none';
    element.appendChild(hitArea);

    const resizeHandle = document.createElement('div');
    resizeHandle.className = 'resize-handle';
    element.appendChild(resizeHandle);

    return element;
  }

  _setupEvents() {
    this.element.addEventListener('mousedown', (e) => {
      if (e.target.classList.contains('resize-handle')) {
        this.managers.resize.startResize(e, this.element);
      } else {
        this.managers.elementActions.handleSelectionAndDrag(e, this.element);
      }
    });
  }

  setWidth(width) {
    this.element.style.width = width + 'px';
  }

  getWidth() {
    return parseInt(this.element.style.width);
  }

  setThickness(thickness) {
    this.element.style.height = thickness + 'px';
    const hitArea = this.element.querySelector('.line-hit-area');
    hitArea.style.display = thickness >= 4 ? 'none' : '';
  }

  getThickness() {
    return parseInt(this.element.style.height);
  }

  setColor(color) {
    this.element.style.backgroundColor = color;
  }

  getColor() {
    return this.element.style.backgroundColor;
  }

  serialize() {
    return {
      ...this.getSerializeBase(),
      type: 'line',
      width: this.element.style.width,
      thickness: this.element.style.height,
      color: this.element.style.backgroundColor
    };
  }

  static fromData(data, managers) {
    return new LineElement(
      managers,
      parseInt(data.left),
      parseInt(data.top),
      parseInt(data.width),
      {
        id: data.id,
        thickness: parseInt(data.thickness) || 1,
        color: data.color || '#000000'
      }
    );
  }
}
